
import GButtonV2 from '../g-button-v2';
import GLazyAsset from '../g-lazy-asset';

export default {
  name: 'g-trial-cta-footer',
  components: {
    GButtonV2,
    GLazyAsset,
  },
  props: {
    title: {
      type: String,
      default: 'Easy employee scheduling and Time & Attendance',
    },
    buttonText: {
      type: String,
      default: 'Try Deputy for Free',
    },
  },
};
